export const ACTION_GET_HAPPINESS_TIPS = "ACTION_GET_HAPPINESS_TIPS";
export const ACTION_POST_CREATE_HAPPINESS_TIPS = "ACTION_POST_CREATE_HAPPINESS_TIPS";
export const ACTION_PUT_UPDATE_HAPPINESS_TIPS = "ACTION_PUT_UPDATE_HAPPINESS_TIPS";
export const ACTION_DELETE_HAPPINESS_TIPS = "ACTION_DELETE_HAPPINESS_TIPS";
